import { app } from '.'
import { hc } from 'hono/client'
import authRoutes from './routes/auth';
import aiRoutes from './routes/ai';
import foodsRoutes from './routes/foods';
// import diaryRoutes from './routes/diary';
import userRoutes from './routes/user';
// import recipesRoutes from './routes/recipes';
// import syncRoutes from './routes/sync'; // deleted — replaced by rxdb route
// import goalsRoutes from './routes/goals';
// import weightHistoryRoutes from './routes/weightHistory';
import sharingRoutes from './routes/sharing';
import shareGroupsRoutes from './routes/shareGroups';
import coachReviewRoutes, { publicCoachReviewRoutes } from './routes/coachReview';
import systemFoodsRoutes from './routes/system-foods';
import foodPhotosRoutes from './routes/food-photos';
import oauthRoutes from './routes/oauth';
import adminUsersRoutes from './routes/admin-users';
import adminActivityRoutes from './routes/admin-activity';
import nutritionPlansRoutes from './routes/nutrition-plans';
import intervalsIcuRoutes from './routes/intervals-icu';
export type {
  NutritionPlannerRequest,
  NutritionPlannerResponse,
} from './nutrition-planner/planner/types';

// this is a trick to calculate the type when compiling
export type Client = ReturnType<typeof hc<typeof app>>

type webFetch = (url: string, init: RequestInit) => Promise<Response>;

// Authentication client - handles login, register, refresh tokens
export const authClient = (fetch: webFetch) => hc<typeof authRoutes>('/auth', { fetch: fetch as any });

// Foods client - handles food search, barcode lookup, custom foods
export const foodsClient = (fetch: webFetch) => hc<typeof foodsRoutes>('/api/foods', { fetch: fetch as any });

// AI client - handles text analysis, photo analysis, and usage reporting
export const aiClient = (fetch: webFetch) => hc<typeof aiRoutes>('/api/ai', { fetch: fetch as any });

// Diary client - handles diary entry CRUD operations
// export const diaryClient = (fetch: webFetch) => hc<typeof diaryRoutes>('/api/diary', { fetch: fetch as any });

// User client - handles user profile and goals management
export const userClient = (fetch: webFetch) => hc<typeof userRoutes>('/api/user', { fetch: fetch as any });

// Goals client - handles goals history operations
// export const goalsClient = (fetch: webFetch) => hc<typeof goalsRoutes>('/api/goals', { fetch: fetch as any });

// Weight history client - handles weight entry operations
// export const weightClient = (fetch: webFetch) => hc<typeof weightHistoryRoutes>('/api/weight', { fetch: fetch as any });

// Recipes client - handles recipe CRUD operations
// export const recipesClient = (fetch: webFetch) => hc<typeof recipesRoutes>('/api/recipes', { fetch: fetch as any });

// Planning client - handles recipe CRUD operations
export const planningClient = (fetch: webFetch) => hc<typeof nutritionPlansRoutes>('/api/planning', { fetch: fetch as any });

// Sync client - legacy, replaced by rxdb route — kept for compatibility
// export const syncClient = (fetch: webFetch) => hc<typeof syncRoutes>('/api/sync', { fetch: fetch as any });

// Sharing client - handles food and recipe sharing operations
export const sharingClient = (fetch: webFetch) => hc<typeof sharingRoutes>('/api/sharing', { fetch: fetch as any });

// Share groups client - handles share group management
export const shareGroupsClient = (fetch: webFetch) => hc<typeof shareGroupsRoutes>('/api/share-groups', { fetch: fetch as any });

// Coach review client - handles private coach review links
export const coachReviewClient = (fetch: webFetch) => hc<typeof coachReviewRoutes>('/api/coach-review', { fetch: fetch as any });

// Public coach review client - reads public review payloads by token
export const publicCoachReviewClient = (fetch: webFetch) => hc<typeof publicCoachReviewRoutes>('/api/coach-review/public', { fetch: fetch as any });

// System foods client - handles admin system food management (admin only)
export const systemFoodsClient = (fetch: webFetch) => hc<typeof systemFoodsRoutes>('/api/admin', { fetch: fetch as any });

// Food photos client - handles admin food photo submission management (admin only)
export const foodPhotosClient = (fetch: webFetch) => hc<typeof foodPhotosRoutes>('/api', { fetch: fetch as any });

// OAuth client - handles OAuth authentication flows
export const oauthClient = (fetch: webFetch) => hc<typeof oauthRoutes>('/auth/oauth', { fetch: fetch as any });

// Admin users client - handles admin user access management
export const adminUsersClient = (fetch: webFetch) => hc<typeof adminUsersRoutes>('/api/admin', { fetch: fetch as any });

// Admin activity client - handles admin daily system activity summary (admin only)
export const adminActivityClient = (fetch: webFetch) => hc<typeof adminActivityRoutes>('/api/admin', { fetch: fetch as any });

// Intervals.icu client - handles workout connection and synchronization
export const intervalsIcuClient = (fetch: webFetch) => hc<typeof intervalsIcuRoutes>('/api/integrations/intervals-icu', { fetch: fetch as any });
